import {
  StyledVow,
  InfoWrapper,
  InfoItem,
  RegionWrapper,
  InfoItemText,
  VideoIcon,
  PrivateIcon,
  CertIcon,
  RingIcon,
  SubtitleText
} from "./styles/StyledVow";
import VideoIconSrc from "../../../../shared/assets/img/video-player_13886853.svg";
import PrivateIconSrc from "../../../../shared/assets/img/blockchain_5966380.svg";
import RingIconSrc from "../../../../shared/assets/img/love_13017871.svg";
import CertIconSrc from "../../../../shared/assets/img/certificate_9865117.svg";
// import FlagsIconSrc from "../assets/img/vow/flags.svg";
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useShallowSelector} from "../../../../shared/hooks";
import {userSelector} from "../../../../entities/user";
import {weddingSelector} from "../../../../entities/wedding";
import {modalActions, ModalType} from "../../../../entities/modal";
import {routes, wsWeddingRoutes} from "../../../../app/providers/router/routes";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import {Stack} from "@mui/material";
import {ButtonOther, ButtonRitual} from "./Hero";

const Vow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: userId } = useShallowSelector(userSelector.getUser);
  const { state } = useShallowSelector(weddingSelector.getWedding);
  const { t } = useTranslation();

  const handleButtonClick = () => {
    if (!userId) {
      dispatch(
          modalActions.openModal({
            type: ModalType.ConnectWallet,
          }),
      );
    } else {
      navigate(state ? wsWeddingRoutes[state] : routes.connection.path);
    }
  };

  const handleButtonClickGift = () => {
    navigate('/help-vows');
  };
  const handleButtonClickMedia = () => {
    navigate('/help-vows');
  };
  return (
    <StyledVow>
      <h2>{t('vow_title')}</h2>
      <SubtitleText>{t('vow_desc')}</SubtitleText>
      <InfoWrapper>
        <InfoItem>
          <VideoIcon src={VideoIconSrc} alt="Video Icon" />
          <h4>{t('vow_title_1')}</h4>
          <InfoItemText>{t('vow_desc_1')}</InfoItemText>
        </InfoItem>
        <InfoItem>
          <PrivateIcon src={PrivateIconSrc} alt="Private Icon" />
          <h4>
            {t('vow_title_2')}
          </h4>
          <InfoItemText>{t('vow_desc_2')}</InfoItemText>
        </InfoItem>
        <InfoItem>
          <RingIcon src={RingIconSrc} alt="Ring Icon" />
          <h4>{t('vow_title_3')}</h4>
          <InfoItemText>{t('vow_desc_3')}</InfoItemText>
        </InfoItem>
        <InfoItem>
          <CertIcon src={CertIconSrc} alt="Diploma Icon" />
          <h4>{t('vow_title_4')}</h4>
          <InfoItemText>
            {t('vow_desc_4')}
          </InfoItemText>
        </InfoItem>
      </InfoWrapper>
      <span>$ 24.95</span>
      <Stack sx={{
        flexDirection: {sm: 'column', md: 'row'},
        marginTop:  {sm: '10px', md: '30px'},
        left: {sm: '0', md: '-35px'},
        position: 'relative',
        gap: {sm: '10px', md: '90px'}
      }}>
        <ButtonOther
            onClick={handleButtonClickMedia}>
          {t('hero_a3')} <ArrowRightAltRoundedIcon/>
        </ButtonOther>
        <ButtonRitual
            onClick={handleButtonClick}>
          {t('hero_a')} <ArrowRightAltRoundedIcon/>
        </ButtonRitual>
        {/*<ButtonOther*/}
        {/*    onClick={handleButtonClick}>*/}
        {/*  {t('hero_a2')} <ArrowRightAltRoundedIcon/>*/}
        {/*</ButtonOther>*/}
      </Stack>
      {/*<RegionWrapper>
        <InfoItemText>{t('vow_desc_6')}</InfoItemText>
         <RegionFlags src={FlagsIconSrc} alt="Flags Icon" />
        <a href="#">{t('vow_desc_7')}</a>
      </RegionWrapper>*/}
    </StyledVow>
  );
};

export default Vow;
